import React, { useEffect, useRef, useState } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import LeftArrow from '../../../assets/left.png'
import RightArrow from '../../../assets/right.png'
import { isEmpty } from 'lodash'
import EditMenu from '../editMenu'
import CustomImage from '../../customImage/customImage'
import AddSection from '../addSection'
import useTemplateHook from '../templateHook'
import MicroSpeciesSliderWrapper from './_microSpeciesSlickSlider'

const MicroSpeciesCardCarousel = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { getTemplateImage, customNavigate } = useTemplateHook()
  const sliderRef = useRef(null)
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const [position, setPosition] = useState('CENTER')
  const [visibleSlides, setVisibleSlides] = useState(8)

  const handleResize = () => {
    if (window.innerWidth > 1025) {
      setVisibleSlides(8)
    } else if (window.innerWidth < 1026 && window.innerWidth > 768) {
      setVisibleSlides(6)
    } else if (window.innerWidth < 769 && window.innerWidth > 640) {
      setVisibleSlides(5)
    } else {
      setVisibleSlides(4)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (data?.card_data?.length > 0 && sliderRef.current) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(0)
      }, 100)
    }
    if (data?.position) {
      setPosition(data?.position || 'CENTER')
    }
  }, [data?.card_data, data?.position])

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          color: 'grey',
          width: '38px',
          height: '38px',
          position: 'absolute',
          top: '40%',
          right: '-20px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${RightArrow})`,
          opacity: '0.5',
        }}
        onClick={onClick}
      >
        <img src={RightArrow} alt="Next" style={{ width: '100%', height: '100%' }} />
      </div>
    )
  }

  console.log(componentData?.data)

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: '40px',
          height: '40px',
          position: 'absolute',
          top: '40%',
          left: '-20px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${LeftArrow})`,
          opacity: '0.5',
        }}
        onClick={onClick}
      >
        <img src={LeftArrow} alt="Previous" style={{ width: '100%', height: '100%' }} />
      </div>
    )
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const settings = {
    dots: false,
    autoplaySpeed: 2500,
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const getPosition = () => {
    if (data?.card_data.length > 7) {
      return ''
    }
    if (position === 'LEFT') {
      return 'start'
    } else if (position === 'RIGHT') {
      return 'end'
    } else {
      return 'center'
    }
  }

  return (
    <div
      className={`w-full py-6 px-4  relative  ${isEdit && hoverState && 'component-hover-class'} `}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      style={{ background: getStyleValue('component_color', 'component_color', '') }}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div style={{ maxWidth: '1269px', margin: '0 auto' }}>
        <p
          style={{ color: getStyleValue('component_color', 'component_heading_color', '') }}
          className="text-xs md:text-sm lg:text-xl mb-8 font-semibold"
        >
          {data?.title}
        </p>
        <MicroSpeciesSliderWrapper
          isFlex={data?.card_data?.length < visibleSlides}
          position={getPosition()}
        >
          <Slider {...settings} ref={sliderRef}>
            {data?.card_data?.map((item) => (
              <div key={item.id} className="cursor-pointer">
                <div
                  className="flex flex-col items-center"
                  onClick={() => handleRedirect(item.link)}
                >
                  <div className="flex items-center justify-center rounded mb-1">
                    <CustomImage
                      imageUrl={getTemplateImage(item?.image_s3key)}
                      imgAlt={item?.card_heading}
                      imgClass="w-full h-[50px] object-contain"
                    />
                  </div>
                  <p
                    className="text-[10px] sm:text-sm md:text-base font-medium text-center lg:whitespace-nowrap"
                    style={{ color: getStyleValue('card_style', 'card_title_heading', '') }}
                  >
                    {item?.card_heading}
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </MicroSpeciesSliderWrapper>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default MicroSpeciesCardCarousel
